import bareActs from "./bareActs.json";

export const aibeSubjectDefinitions = [

  // =========================================================
  // HIGH PRIORITY
  // =========================================================

  // Constitutional Law
  {
    id: "subject-1",
    key: "constitution",
    name: "Constitution of India",
    group: "Constitutional Law",
    questionKey: "constitution",
    bareActKey: "constitution",
  },

  // CrPC / BNSS
  {
    id: "subject-2",
    key: "crpc",
    name: "Code of Criminal Procedure, 1973",
    group: "CrPC / BNSS",
    questionKey: "crpc",
    bareActKey: "crpc",
  },
  {
    id: "subject-3",
    key: "bnss",
    name: "Bharatiya Nagarik Suraksha Sanhita, 2023",
    group: "CrPC / BNSS",
    questionKey: "bnss",
    bareActKey: "bnss",
  },

  // CPC
  {
    id: "subject-4",
    key: "cpc",
    name: "Code of Civil Procedure, 1908",
    group: "CPC",
    questionKey: "cpc",
    bareActKey: "cpc",
  },

  // Evidence Act / BSA
  {
    id: "subject-5",
    key: "evidence",
    name: "Indian Evidence Act, 1872",
    group: "Evidence Act / BSA",
    questionKey: "evidence",
    bareActKey: "evidence",
  },
  {
    id: "subject-6",
    key: "bsa",
    name: "Bharatiya Sakshya Adhiniyam, 2023",
    group: "Evidence Act / BSA",
    questionKey: "bsa",
    bareActKey: "bsa",
  },

  // Law of Contract & Specific Relief
  {
    id: "subject-7",
    key: "contracts",
    name: "Indian Contract Act, 1872",
    group: "Law of Contract & Specific Relief",
    questionKey: "contracts",
    bareActKey: "contracts",
  },
  {
    id: "subject-8",
    key: "specific_relief",
    name: "Specific Relief Act, 1963",
    group: "Law of Contract & Specific Relief",
    questionKey: "specific_relief",
    bareActKey: "specific_relief",
  },

  // Family Law
  {
    id: "subject-9",
    key: "hindu_marriage",
    name: "Hindu Marriage Act, 1955",
    group: "Family Law",
    questionKey: "hindu_marriage",
    bareActKey: "hindu_marriage",
  },
  {
    id: "subject-10",
    key: "hindu_succession",
    name: "Hindu Succession Act, 1956",
    group: "Family Law",
    questionKey: "hindu_succession",
    bareActKey: "hindu_succession",
  },
  {
    id: "subject-11",
    key: "hindu_minority_guardianship",
    name: "Hindu Minority and Guardianship Act, 1956",
    group: "Family Law",
    questionKey: "hindu_minority_guardianship",
    bareActKey: "hindu_minority_guardianship",
  },
  {
    id: "subject-12",
    key: "hindu_adoption_maintenance",
    name: "Hindu Adoptions and Maintenance Act, 1956",
    group: "Family Law",
    questionKey: "hindu_adoption_maintenance",
    bareActKey: "hindu_adoption_maintenance",
  },
  {
    id: "subject-13",
    key: "dissolution_muslim_marriages",
    name: "Dissolution of Muslim Marriages Act, 1939",
    group: "Family Law",
    questionKey: "dissolution_muslim_marriages",
    bareActKey: "dissolution_muslim_marriages",
  },
  {
    id: "subject-14",
    key: "muslim_women",
    name: "Muslim Women (Protection of Rights on Divorce) Act, 1986",
    group: "Family Law",
    questionKey: "muslim_women",
    bareActKey: "muslim_women",
  },
  {
    id: "subject-15",
    key: "muslim_women_marriage",
    name: "Muslim Women (Protection of Rights on Marriage) Act, 2019",
    group: "Family Law",
    questionKey: "muslim_women_marriage",
    bareActKey: "muslim_women_marriage",
  },
  {
    id: "subject-16",
    key: "muslim_personal_law",
    name: "Muslim Personal Law (Shariat) Application Act, 1937",
    group: "Family Law",
    questionKey: "muslim_personal_law",
    bareActKey: "muslim_personal_law",
  },
  {
    id: "subject-17",
    key: "disposition_of_property",
    name: "Hindu Disposition of Property Act, 1986",
    group: "Family Law",
    questionKey: "disposition_of_property",
    bareActKey: "disposition_of_property",
  },

  // IPC / BNS
  {
    id: "subject-18",
    key: "ipc",
    name: "Indian Penal Code, 1860",
    group: "IPC / BNS",
    questionKey: "ipc",
    bareActKey: "ipc",
  },
  {
    id: "subject-19",
    key: "bns",
    name: "Bharatiya Nyaya Sanhita, 2023",
    group: "IPC / BNS",
    questionKey: "bns",
    bareActKey: "bns",
  },


  // =========================================================
  // MEDIUM PRIORITY
  // =========================================================

  // Professional Ethics & BCI
  {
    id: "subject-20",
    key: "advocates",
    name: "Advocates Act, 1961",
    group: "Professional Ethics & BCI",
    questionKey: "advocates",
    bareActKey: "advocates",
  },

  // Law of Torts & Motor Vehicles
  {
    id: "subject-21",
    key: "motor_vehicles",
    name: "Motor Vehicles Act, 1988",
    group: "Law of Torts & Motor Vehicles",
    questionKey: "motor_vehicles",
    bareActKey: "motor_vehicles",
  },

  // Arbitration & Conciliation
  {
    id: "subject-22",
    key: "adr",
    name: "Arbitration and Conciliation Act, 1996",
    group: "Arbitration & Conciliation",
    questionKey: "adr",
    bareActKey: "adr",
  },

  // Consumer Protection
  {
    id: "subject-23",
    key: "consumer_protection",
    name: "Consumer Protection Act, 2019",
    group: "Consumer Protection",
    questionKey: "consumer_protection",
    bareActKey: "consumer_protection",
  },

  // Transfer of Property
  {
    id: "subject-24",
    key: "transfer_of_property",
    name: "Transfer of Property Act, 1882",
    group: "Transfer of Property",
    questionKey: "transfer_of_property",
    bareActKey: "transfer_of_property",
  },

  // Limitation
  {
    id: "subject-25",
    key: "limitation",
    name: "Limitation Act, 1963",
    group: "Limitation",
    questionKey: "limitation",
    bareActKey: "limitation",
  },

  // Negotiable Instruments
  {
    id: "subject-26",
    key: "negotiable_instruments",
    name: "Negotiable Instruments Act, 1881",
    group: "Negotiable Instruments",
    questionKey: "negotiable_instruments",
    bareActKey: "negotiable_instruments",
  },

  // Intellectual Property Rights
  {
    id: "subject-27",
    key: "trademarks",
    name: "Trade Marks Act, 1999",
    group: "Intellectual Property Rights",
    questionKey: "trademarks",
    bareActKey: "trademarks",
  },
  {
    id: "subject-28",
    key: "copyright",
    name: "Copyright Act, 1957",
    group: "Intellectual Property Rights",
    questionKey: "copyright",
    bareActKey: "copyright",
  },
  {
    id: "subject-29",
    key: "patents",
    name: "Patents Act, 1970",
    group: "Intellectual Property Rights",
    questionKey: "patents",
    bareActKey: "patents",
  },

  // Land Laws
  {
    id: "subject-30",
    key: "land_acquisition",
    name: "Right to Fair Compensation and Transparency in Land Acquisition, Rehabilitation and Resettlement Act, 2013",
    group: "Land Laws",
    questionKey: "land_acquisition",
    bareActKey: "land_acquisition",
  },


  // =========================================================
  // LOW PRIORITY
  // =========================================================

  // Administrative Law
  {
    id: "subject-31",
    key: "administrative_tribunals",
    name: "Administrative Tribunals Act, 1985",
    group: "Administrative Law",
    questionKey: "administrative_tribunals",
    bareActKey: "administrative_tribunals",
  },

  // Cyber Law
  {
    id: "subject-32",
    key: "it_act",
    name: "Information Technology Act, 2000",
    group: "Cyber Law",
    questionKey: "it_act",
    bareActKey: "it_act",
  },

  // Environmental Law
  {
    id: "subject-33",
    key: "environment_protection",
    name: "Environment (Protection) Act, 1986",
    group: "Environmental Law",
    questionKey: "environment_protection",
    bareActKey: "environment_protection",
  },
  {
    id: "subject-34",
    key: "air_pollution",
    name: "Air (Prevention and Control of Pollution) Act, 1981",
    group: "Environmental Law",
    questionKey: "air_pollution",
    bareActKey: "air_pollution",
  },
  {
    id: "subject-35",
    key: "water_pollution",
    name: "Water (Prevention and Control of Pollution) Act, 1974",
    group: "Environmental Law",
    questionKey: "water_pollution",
    bareActKey: "water_pollution",
  },
  {
    id: "subject-36",
    key: "national_green_tribunal",
    name: "National Green Tribunal Act, 2010",
    group: "Environmental Law",
    questionKey: "national_green_tribunal",
    bareActKey: "national_green_tribunal",
  },

  // Company Law
  {
    id: "subject-37",
    key: "companies",
    name: "Companies Act, 2013",
    group: "Company Law",
    questionKey: "companies",
    bareActKey: "companies",
  },

  // Labour & Industrial Law
  {
    id: "subject-38",
    key: "contract_labour",
    name: "Contract Labour (Regulation and Abolition) Act, 1970",
    group: "Labour & Industrial Law",
    questionKey: "contract_labour",
    bareActKey: "contract_labour",
  },
  {
    id: "subject-39",
    key: "employees_compensation",
    name: "Employees' Compensation Act, 1923",
    group: "Labour & Industrial Law",
    questionKey: "employees_compensation",
    bareActKey: "employees_compensation",
  },
  {
    id: "subject-40",
    key: "equal_remuneration",
    name: "Equal Remuneration Act, 1976",
    group: "Labour & Industrial Law",
    questionKey: "equal_remuneration",
    bareActKey: "equal_remuneration",
  },
  {
    id: "subject-41",
    key: "factories",
    name: "Factories Act, 1948",
    group: "Labour & Industrial Law",
    questionKey: "factories",
    bareActKey: "factories",
  },
  {
    id: "subject-42",
    key: "industrial_disputes",
    name: "Industrial Disputes Act, 1947",
    group: "Labour & Industrial Law",
    questionKey: "industrial_disputes",
    bareActKey: "industrial_disputes",
  },
  {
    id: "subject-43",
    key: "industrial_employment",
    name: "Industrial Employment (Standing Orders) Act, 1946",
    group: "Labour & Industrial Law",
    questionKey: "industrial_employment",
    bareActKey: "industrial_employment",
  },
  {
    id: "subject-44",
    key: "minimum_wages",
    name: "Minimum Wages Act, 1948",
    group: "Labour & Industrial Law",
    questionKey: "minimum_wages",
    bareActKey: "minimum_wages",
  },
  {
    id: "subject-45",
    key: "payment_of_wages",
    name: "Payment of Wages Act, 1936",
    group: "Labour & Industrial Law",
    questionKey: "payment_of_wages",
    bareActKey: "payment_of_wages",
  },
  {
    id: "subject-46",
    key: "trade_unions",
    name: "Trade Unions Act, 1926",
    group: "Labour & Industrial Law",
    questionKey: "trade_unions",
    bareActKey: "trade_unions",
  },

  // Other / Additional Statutes
  {
    id: "subject-47",
    key: "maternity_benefit",
    name: "Maternity Benefit Act, 1961",
    group: "Other / Additional Statutes",
    questionKey: "maternity_benefit",
    bareActKey: "maternity_benefit",
  },
  {
    id: "subject-48",
    key: "jan_vishwas",
    name: "Jan Vishwas (Amendment of Provisions) Act, 2023",
    group: "Other / Additional Statutes",
    questionKey: "jan_vishwas",
    bareActKey: "jan_vishwas",
  },
];

export const aibeSubjects = aibeSubjectDefinitions.map((subject) => ({
  ...subject,
  displayName: subject.name,
  pdfUrl: bareActs[subject.bareActKey]?.pdfUrl || "",
  questions: [],
  answers: [],
  explanations: [],
  metadata: {},
}));


// =============================================================
// AIBE PREVIOUS YEAR PAPERS
// AIBE 05 → AIBE 21
// =============================================================

export const aibePreviousPapers = Array.from(
  { length: 17 },
  (_, index) => {
    const number = index + 5;
    const twoDigit = String(number).padStart(2, "0");
    const id = `aibe${twoDigit}`;

    return {
      id,
      name: `AIBE ${twoDigit}`,
      displayName: `AIBE ${twoDigit}`,
      year: `AIBE ${twoDigit}`,
      datasetKey: id,
      questions: [],
      answers: [],
      explanations: [],
      metadata: {},
    };
  }
);


// =============================================================
// OFFICIAL AIBE SYLLABUS
// =============================================================

export const aibeOfficialSyllabus = {
  id: "official-aibe-syllabus",
  name: "Official AIBE Syllabus",
    group: "Other / Additional Statutes",
  pdfUrl:
    "https://www.allindiabarexamination.com/img/Syllabus%20for%20All%20India%20Bar%20Exam-XXI.pdf",
};